module.exports = __webpack_public_path__ + "static/media/wedding-splash.c33a9795.JPG";